// STYLES
import './_footer.scss'

// LIBS
import React from 'react'

// INTERFACE
const Footer = () =>
  <footer id="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-3 detail-cell hq-social-details">
          <h5>Connect With Us</h5>
          <ul className="hq-social-list">
            <li><a target="_blank" href="https://www.facebook.com/codefellows.org">Facebook</a></li>
            <li><a target="_blank" href="https://www.instagram.com/codefellows">Instagram</a></li>
             <li><a target="_blank" href="https://www.tiktok.com/@codefellows">TikTok</a></li>
            <li><a target="_blank" href="https://twitter.com/CodeFellows">Twitter</a></li>
            <li><a target="_blank" href="https://www.linkedin.com/company/code-fellows">LinkedIn</a></li>
            <li><a target="_blank" href="https://www.youtube.com/channel/UCbAjy7CL-wn9XuVTvkfD4KQ">YouTube</a></li>
            <li><a href="/meet-the-team/">Meet the Team</a></li>
          </ul>
        </div>
        <div className="col-md-3 detail-cell hq-information-details">
          <h5>Learn More</h5>
          <ul className="hq-social-list">
            <li><a href="https://www.washingtontechnology.org/code-fellows/">Scholarship Fund Donations</a></li>
            <li><a href="/blog/">Blog</a></li>
            <li><a href="/press/">Press</a></li>
            <li><a href="/about/">Our Story</a></li>
            <li><a href="/premier-tech-academy/">Premier Tech Academy</a></li>
            <li><a href="/jobs-at-code-fellows/">Careers</a></li>
            <li><a href="/privacy-policy/" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
        <div className="col-md-3 detail-cell hq-contact-details">
          <h5>Advisors Available</h5>
          <ul className="hq-social-list">
            <li className="schedule-list">Monday - Friday<br/>
            9:00 a.m. - 5:00 p.m.<br/>Saturday - Sunday<br/>
            9:00 a.m. - 12:00 p.m.<br/>
         </li>
          </ul>
          <br />
        </div>
        <div className="col-md-3 detail-cell hq-contact-details">
          <h5>Get in Touch</h5>
          <ul className="hq-social-list">
            <li><a href="https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=footer&utm_medium=website&utm_content=footer&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic">Apply Now</a></li>
            <li><span className="contact-options">Call: </span><a href="tel:2066819318">
              206-681-9318
            </a></li>
          </ul>
          <address hidden className="hq-address">
            <a
              target="_blank"
              href="https://www.google.com/maps?newwindow=1&biw=1265&bih=786&q=2901+3rd+Ave,+Suite+300+seattle+wa&bav=on.2,or.r_cp.&bvm=bv.117218890,d.cGc&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjM5fvJ4sjLAhVE0WMKHbtCAqAQ_AUIBigB"
            >
              2901 3rd Ave. Suite 300 <br />
              Seattle, WA 98121 <br />
            </a>
          </address>
        </div>
      </div>
      <br />
      <div className="social-buttons">
        <a href="https://www.facebook.com/codefellows.org" target="_blank"><span className="fb-light"></span></a>
        <a href="https://twitter.com/codefellows" target="_blank"><span className="tw-light"></span></a>
        <a href="https://www.instagram.com/codefellows/" target="_blank"><span className="ig-light"></span></a>
        <a href="https://www.linkedin.com/school/2877757" target="_blank">  <span className="li-light"></span></a>
      </div>
      <p className="copyright">
        &copy;&nbsp;{new Date().getFullYear()}&nbsp;Code Fellows, Inc.
        Code Fellows is a licensed Technical Education provider by the state of Washington.</p>
        <hr />
        <p className="copyright" id="footer-link">
        <a href="/regulatory-information/">Regulatory Information</a> | GI Bill&reg; is a registered trademark of the U.S. Department of Veterans Affairs (VA). More information about education benefits offered by VA is available at the official U.S. government Web site at <a href="https://www.benefits.va.gov/gibill">www.benefits.va.gov/gibill</a>.
        </p>
        <hr />
        <p className="copyright">
        In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, sex, religious creed, disability, age, political beliefs, or reprisal or retaliation for prior civil rights activity in any program or activity conducted or funded by USDA.
      </p>
      <hr />
      <p className="copyright" id="footer-link">
        <a href="https://app.termly.io/document/cookie-policy/fa299c0a-b520-47dc-892c-0e610845b2cd" target="_blank">Cookie Policy</a> | <a href="#" id="termly-consent-preferences" onClick={() => {window.displayPreferenceModal();return false;}}>Consent Preferences</a> | <a href="https://app.termly.io/notify/dbd20a14-2d73-49a5-9c43-d3651604bd3c" target="_blank">Do Not Sell or Share My Personal information</a> | <a href="https://app.termly.io/notify/dbd20a14-2d73-49a5-9c43-d3651604bd3c" target="_blank">Limit the Use Of My Sensitive Personal Information</a>
      </p>
    </div>
  </footer>

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js